import React, { type CSSProperties } from "react";
import "@/App.css";

type LoadingIndicatorChildren = {
  className?: string;
  style?: CSSProperties;
}

export const LoadingIndicator: React.FC<LoadingIndicatorChildren> = ({ className, style}) => {
  return (
    <div className={className} style={style}>
      <div
        className="relative w-[30px] h-[15px] rounded-lg bg-musio-border"
      >
        <div
          className="absolute w-[10px] h-[10px] rounded-full loading-ball bg-musio-primary"
        ></div>
      </div>
    </div>
  );
};
